var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeadFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 291.73,
    y1: 210.94,
    x2: 1754.03,
    y2: 1858.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7ae30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1008.83,
    y1: 1017.48,
    x2: 1678.75,
    y2: 1676.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca4f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4901f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 340.54,
    y1: 338.79,
    x2: 802.93,
    y2: 808.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffca4f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1000.25,
    y1: 1251.83,
    x2: 1000.25,
    y2: 1458.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7ae30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffca4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1348.16,
    y1: 457.26,
    x2: 1348.16,
    y2: 880.99,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 652.35,
    y1: 457.26,
    x2: 652.35,
    y2: 880.99,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1000.25,
    y1: 1304.38,
    x2: 1000.25,
    y2: 1407.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1348.16,
    y1: 498.03,
    x2: 1348.16,
    y2: 837.01,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 652.35,
    y1: 498.03,
    x2: 652.35,
    y2: 837.01,
    xlinkHref: "#linear-gradient-7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1000.25,1965.77c-527.55,0-956.75-429.19-956.75-956.75S472.7,52.28,1000.25,52.28s956.75,429.19,956.75,956.75-429.19,956.75-956.75,956.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.05,1685.23c173.24,173.24,412.43,280.54,676.21,280.54,527.55,0,956.75-429.19,956.75-956.75,0-263.78-107.3-502.96-280.54-676.21L324.05,1685.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M565.37,1443.91c0-479.58,390.19-869.77,869.77-869.77,127.4,0,248.11,28.21,357.25,77.64-136.64-301.72-439.95-512.52-792.13-512.52-479.58,0-869.77,390.19-869.77,869.77,0,352.19,210.8,655.49,512.52,792.13-49.43-109.14-77.64-229.85-77.64-357.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M608.86,1443.91c-47.97,0-86.98-39.01-86.98-86.98s39.01-86.98,86.98-86.98h782.79c47.97,0,86.98,39.01,86.98,86.98s-39.01,86.98-86.98,86.98h-782.79Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1478.63,878.56c-23.23,0-45.06-9.05-61.5-25.48l-68.97-68.97-68.97,68.97c-16.44,16.44-38.26,25.48-61.5,25.48s-45.06-9.05-61.5-25.48c-16.44-16.44-25.48-38.26-25.48-61.5s9.05-45.06,25.48-61.5l68.97-68.97-68.97-68.97c-16.44-16.44-25.48-38.26-25.48-61.5s9.05-45.06,25.48-61.5c16.44-16.44,38.26-25.48,61.5-25.48s45.06,9.05,61.5,25.48l68.97,68.97,68.97-68.97c16.44-16.44,38.26-25.48,61.5-25.48s45.06,9.05,61.5,25.48c16.44,16.44,25.48,38.26,25.48,61.5s-9.05,45.06-25.48,61.5l-68.97,68.97,68.97,68.97c16.44,16.44,25.48,38.26,25.48,61.5s-9.05,45.06-25.48,61.5c-16.44,16.44-38.26,25.48-61.5,25.48Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M782.81,878.56c-23.23,0-45.06-9.05-61.5-25.48l-68.97-68.97-68.97,68.97c-16.44,16.44-38.26,25.48-61.5,25.48s-45.06-9.05-61.5-25.48c-16.44-16.44-25.48-38.26-25.48-61.5s9.05-45.06,25.48-61.5l68.97-68.97-68.97-68.97c-16.44-16.44-25.48-38.26-25.48-61.5s9.05-45.06,25.48-61.5c16.44-16.44,38.26-25.48,61.5-25.48s45.06,9.05,61.5,25.48l68.97,68.97,68.97-68.97c16.44-16.44,38.26-25.48,61.5-25.48s45.06,9.05,61.5,25.48c16.44,16.44,25.48,38.26,25.48,61.5s-9.05,45.06-25.48,61.5l-68.97,68.97,68.97,68.97c16.44,16.44,25.48,38.26,25.48,61.5s-9.05,45.06-25.48,61.5c-16.44,16.44-38.26,25.48-61.5,25.48Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1391.65,1400.42h-782.79c-24.02,0-43.49-19.47-43.49-43.49s19.47-43.49,43.49-43.49h782.79c24.02,0,43.49,19.47,43.49,43.49s-19.47,43.49-43.49,43.49Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1409.66,661.12l99.72-99.72c16.99-16.99,16.99-44.51,0-61.5-16.99-16.99-44.51-16.99-61.5,0l-99.72,99.72-99.72-99.72c-16.99-16.99-44.51-16.99-61.5,0-16.99,16.99-16.99,44.51,0,61.5l99.72,99.72-99.72,99.72c-16.99,16.99-16.99,44.51,0,61.5,8.49,8.49,19.62,12.74,30.75,12.74s22.25-4.25,30.75-12.74l99.72-99.72,99.72,99.72c8.49,8.49,19.62,12.74,30.75,12.74s22.25-4.25,30.75-12.74c16.99-16.99,16.99-44.51,0-61.5l-99.72-99.72Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M713.84,661.12l99.72-99.72c16.99-16.99,16.99-44.51,0-61.5-16.99-16.99-44.51-16.99-61.5,0l-99.72,99.72-99.72-99.72c-16.99-16.99-44.51-16.99-61.5,0-16.99,16.99-16.99,44.51,0,61.5l99.72,99.72-99.72,99.72c-16.99,16.99-16.99,44.51,0,61.5,8.49,8.49,19.62,12.74,30.75,12.74s22.25-4.25,30.75-12.74l99.72-99.72,99.72,99.72c8.49,8.49,19.62,12.74,30.75,12.74s22.25-4.25,30.75-12.74c16.99-16.99,16.99-44.51,0-61.5l-99.72-99.72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadFace);
export default __webpack_public_path__ + "static/media/Dead Face.1d2dfd977e9a2eafdbb04a035b62301e.svg";
export { ForwardRef as ReactComponent };